const downloadFile = async (urlFile: any) => {
  if (urlFile) {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";

    // Extract the file name from the URL
    const urlParts = urlFile.split("/");
    const fileName = urlParts[urlParts.length - 1];

    a.href = urlFile;
    a.target = "_blank";
    a.download = fileName;
    a.click();
  }
};

export default downloadFile;
